﻿export class AddOn {
    _id: string;
    name: string;
    price: number;
}